<script>
export default {
  props: {
    text: {
      default: '',
      type: String
    },
    item: {
      default: '',
      type: String
    },
    iconFontSize: {
      default: '3em',
      type: String
    },
    hideButton: Boolean
  }
}
</script>
<template>
  <div class="d-flex flex-column empty-content">
    <v-icon class="empty-icon" :style="{ fontSize: iconFontSize }">mdi-package-variant</v-icon>
    <p class="empty-text">
      {{ text }}
    </p>
    <v-btn v-if="!hideButton" color="primary" @click="$emit('create')" elevation="0"
      >Thêm {{ item }} <v-icon class="mb-1" right>add</v-icon></v-btn
    >
  </div>
</template>
<style scoped>
.empty-content {
  max-width: 600px;
  margin: auto;
  min-height: 200px;
  justify-content: center;
  align-items: center;
}
.empty-icon {
  margin-bottom: 16px;
}
.empty-text {
  text-align: center;
}
</style>
